module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-block"
  }, [_c('nav', [_c('router-link', {
    staticClass: "nav-link nav-link--normal",
    attrs: {
      "to": "/"
    }
  }, [_vm._v("Merten Hanisch")]), _vm._v(" "), _c('span', {
    staticClass: "hide-mobile"
  }, [_vm._v("| ")]), _vm._v(" "), _c('ul', _vm._l((_vm.pages), function(page) {
    return (!page.hideFromMenu) ? _c('li', [_c('router-link', {
      staticClass: "nav-link",
      attrs: {
        "to": page.path,
        "exact": ""
      }
    }, [_vm._v(_vm._s(page.name))]), _vm._v(" "), _c('span', [_vm._v("| ")])], 1) : _vm._e()
  }))], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2af82f82"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/navmain.vue
// module id = 83
// module chunks = 1